import * as tslib_1 from "tslib";
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { DynamicContentOutletErrorComponent } from './components/dynamic-content-outlet-error/dynamic-content-outlet-error.component'; // Reference directly rather than barrel avoid circular reference.
import { DynamicOutletRegistryService } from './dynamic-outlet.registry';
import { ModuleLoaderService } from './module-loader.service';
import * as i0 from "@angular/core";
import * as i1 from "./module-loader.service";
import * as i2 from "./dynamic-outlet.registry";
var DynamicOutletService = /** @class */ (function () {
    function DynamicOutletService(componentFactoryResolver, moduleLoaderService, registryService, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.moduleLoaderService = moduleLoaderService;
        this.registryService = registryService;
        this.injector = injector;
    }
    DynamicOutletService.prototype.getComponent = function (componentName, localInjector) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var component, module, componentType;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                component = this.registryService.get(componentName);
                if (component == null) {
                    return [2 /*return*/, this.getDynamicContentErrorComponent("Unable to locate " + componentName)];
                }
                module = component.module, componentType = component.componentType;
                if (module == null) {
                    return [2 /*return*/, this.getDynamicContentErrorComponent("Unable to derive modulePath from component: " + componentName)];
                }
                if (componentType == null) {
                    return [2 /*return*/, this.getDynamicContentErrorComponent("Unable to derive componentType from component: " + componentName)];
                }
                return [2 /*return*/, this.moduleLoaderService.getOrLoad(module)
                        .pipe(map(function (p) {
                        if (typeof componentType === 'string') { // Resolve Component Type
                            var componentRef = _this.registryService.get(componentType);
                            if (componentRef == null || typeof componentRef.componentType === 'string') {
                                var msg = "Component Type '" + componentType + "' is not defined";
                                console.warn(msg, componentRef);
                                return _this.getDynamicContentErrorComponent(msg);
                            }
                            componentType = componentRef.componentType;
                        }
                        var componentResolver = p.componentFactoryResolver;
                        var componentFactory = componentResolver.resolveComponentFactory(componentType);
                        var result = componentFactory.create(localInjector);
                        return result;
                    }), catchError(function (error) {
                        console.error(error.message);
                        return of(_this.getDynamicContentErrorComponent("Unable to load module " + module + ". Looked up using component: " + componentName + ". Error Details: " + error.message));
                    })).toPromise()];
            });
        });
    };
    DynamicOutletService.prototype.getDynamicContentErrorComponent = function (errorMessage) {
        var factory = this.componentFactoryResolver.resolveComponentFactory(DynamicContentOutletErrorComponent);
        var componentRef = factory.create(this.injector);
        var instance = componentRef.instance;
        instance.errorMessage = errorMessage;
        return componentRef;
    };
    DynamicOutletService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DynamicOutletService_Factory() { return new DynamicOutletService(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i1.ModuleLoaderService), i0.ɵɵinject(i2.DynamicOutletRegistryService), i0.ɵɵinject(i0.INJECTOR)); }, token: DynamicOutletService, providedIn: "root" });
    return DynamicOutletService;
}());
export { DynamicOutletService };
